/**
 * Open and close accordion content
 */
window.addEventListener( 'DOMContentLoaded', () => {

	const accordions = document.querySelectorAll( '.wp-block-pik-accordion' );

    if ( accordions.length === 0 ) {
        return;
    }

    for ( const accordion of accordions ) {
        const title = accordion.querySelector( '.wp-block-pik-accordion__title' );

        title.addEventListener( 'click', ( event ) => {

            const thisAccordion = event.target.closest( '.wp-block-pik-accordion' );
            
            for ( const accordion of accordions ) {
                const title = accordion.querySelector( '.wp-block-pik-accordion__title' );

                if ( accordion.classList.contains( 'wp-block-pik-accordion--active' ) && accordion !== thisAccordion ) {
                    accordion.classList.remove( 'wp-block-pik-accordion--active' );
                    title.setAttribute( 'aria-expanded', 'false' );
                }
            }

            thisAccordion.classList.toggle( 'wp-block-pik-accordion--active' );

            if ( title.getAttribute( 'aria-expanded' ) === 'false' ) {
                title.setAttribute( 'aria-expanded', 'true' );
            } else {
                title.setAttribute( 'aria-expanded', 'false' );
            }
        } )
    }
} )
